import '@styles/global.scss';
import '@splidejs/react-splide/css';

import {
  AppContext,
  CustomThemeProvider,
  useAppContextState,
  GdprProvider,
} from '@containers';
import Script from 'next/script';
import { appWithTranslation } from 'next-i18next';
import { getCookie, hasCookie } from 'cookies-next';

function App({ Component, pageProps, router }) {
  //? initialize context
  const appContextState = useAppContextState();
  const consent = getCookie('localConsent');
  console.info({
    hasCookie: hasCookie('localConsent'),
  });
  return (
    <>
      <AppContext.Provider value={appContextState}>
        <Script
          src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GA_TRACKING_ID}`}
          strategy="afterInteractive"
        />
        <Script id="google-analytics" strategy="afterInteractive">
          {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', '${process.env.NEXT_PUBLIC_GA_TRACKING_ID}');
        `}
        </Script>
        <Script
          id="gtag"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}

            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                      })(window,document,'script','dataLayer','GTM-NVFMZR8');`,
          }}
        />
        {hasCookie('localConsent') && consent && (
          <>
            <Script
              id="consupd"
              strategy="afterInteractive"
              dangerouslySetInnerHTML={{
                __html: `
            gtag('consent', 'update', {
              'ad_storage': 'granted',
              'analytics_storage': 'granted'
            });
          `,
              }}
            />
          </>
        )}
        <CustomThemeProvider>
          <GdprProvider>
            <Component {...pageProps} key={router.asPath} />
          </GdprProvider>
        </CustomThemeProvider>
      </AppContext.Provider>
    </>
  );
}

export default appWithTranslation(App /*, nextI18NextConfig */);
